module.exports = __webpack_public_path__ + "static/media/path1.ed790a99.svg";